function Hotspots(){

    console.log("------------------------ Hotspots");

    //this.$hotspot = $(".hotspot");
    //this.$overlay =

    var self = this;

    self.numberOfStories = $(".left").length;

    //console.log(this.stories);

    self.stories = [];

    for (var i=0; i < self.numberOfStories; i ++){

        var h = new Hotspot(i, "#p", 500);

        self.stories.push(h);

    }

    self.numberOfPosts = $(".post").length;

    console.log(" number of posts " + self.numberOfPosts);

    self.posts = [];

    for (var j=0; j < self.numberOfPosts; j ++){

      console.log("j ", j)

        var p = new HotspotRight(j, "#b", 500);

        self.posts.push(p);

    }



    /*

    $( ".hotspot" ).each(function( index ) {

        var delay = 0.7;
        var timeout;
        var mouseover = false;

        $(this).mouseover(function() {

            if (mouseover === false) {

                mouseover = true;

                clearTimeout(timeout);

                console.log("over");

                var $hover = $(this).siblings(".hover");

                TweenMax.set($hover, {scaleX: 1, scaleY: 1});

                TweenMax.to($hover, 0.2, {autoAlpha: 0.8, scaleX: 1.2, scaleY: 1.2});

            }


        });
        $(this).mouseout(function() {

            if (mouseover === true) {

                var $hover = $(this).siblings(".hover");

                clearTimeout(timeout);

                timeout = setTimeout(function () {

                    //mouseover = true;

                    TweenMax.to($hover, 0.25, {autoAlpha: 0, scaleX: 1, scaleY: 1});

                    mouseover = false;

                }, 1000);

            }

        });

        //console.log( index + ": " + $( this ).text() );
    });

    ]*/


}

Hotspots.prototype.resize = function () {

   /* var self= this;

    this.outerHeight = self.$id.height();
    this.innerHeight = self.$c1.height();

    //console.log("outer height " + this.outerHeight + " innerHeight " + this.innerHeight);

    self.offset = (this.outerHeight - this.innerHeight) /2;

    TweenMax.set(self.$c1, {css:{marginTop:self.offset}});*/

};



